/**
 * SourceGenerator Create Page
 * Create new source generator
 *
 * @version 2025.1.0
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  Card,
  CardContent,
} from '@mui/material';
import { PageShell } from '../../components';
import { sourceGeneratorService } from '../../services/sourceGeneratorService';
import { SourceGeneratorFormData } from '../../types/sourceGenerator';
import { SourceGeneratorForm } from './components/SourceGeneratorForm';

export const SourceGeneratorCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: SourceGeneratorFormData) => {
    try {
      setLoading(true);
      setError(null);

      console.log('[CreatePage] Creating source generator:', data);

      await sourceGeneratorService.createSourceGenerator(data);

      console.log('[CreatePage] Source generator created successfully');

      navigate('/source-generators');
    } catch (err: unknown) {
      const error = err as Error;
      console.error('[CreatePage] Error creating source generator:', error);
      setError(error.message ?? 'Erro ao criar fonte geradora');
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/source-generators');
  };

  return (
    <PageShell
      breadcrumbs={[
        { label: 'Início', path: '/' },
        { label: 'Fontes Geradoras', path: '/source-generators' },
        { label: 'Nova Fonte' },
      ]}
      title="Nova Fonte Geradora"
      subtitle="Cadastre uma nova fonte geradora de riscos ocupacionais"
    >
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <Card>
        <CardContent sx={{ p: 3 }}>
          <SourceGeneratorForm
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            loading={loading}
          />
        </CardContent>
      </Card>
    </PageShell>
  );
};

export default SourceGeneratorCreatePage;
